import { Accordion } from "react-bootstrap";
import { FORM_KEYS } from "./helper";
import AsteriskSymbol from "../../../../reusableComponents/AsteriskSymbol";
import { claimIntimatedByOptions, OTHER } from "../../../../consts";
import Select from 'react-select';
import { useEffect, useState } from "react";
import { fetchRelations } from "./apiHelper";

const ClaimIntimatedDetails = ({ formData, setValue, customStyles, relationshipList }) => {

    return <>
        <Accordion className='accordion m-2' defaultActiveKey="0">
            <Accordion.Item eventKey="0">
                <Accordion.Header>
                    Claim Intimated Details
                </Accordion.Header>
                <Accordion.Body>
                    <div className="row">
                        <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                            <p className="align3Policy">Claim Intimated By <AsteriskSymbol /></p>
                            <Select
                                classNamePrefix="truncate-placeholder"
                                options={claimIntimatedByOptions}
                                styles={customStyles}
                                value={formData[FORM_KEYS.intimated_by] ? formData[FORM_KEYS.intimated_by] : null}
                                onChange={(selectedOption) => {
                                    setValue(FORM_KEYS.intimated_by, selectedOption);
                                    setValue(FORM_KEYS.intimator_name, "");
                                    setValue(FORM_KEYS.relationship, "")
                                }}
                                placeholder="Claim Intimated By"
                            />
                        </div>
                        {formData[FORM_KEYS.intimated_by]?.value === OTHER && (
                            <>
                                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 claim-intimator-container">
                                    <p className="align3Policy">Claim Intimator Name <AsteriskSymbol /></p>
                                    <input
                                        className="claim-intimator-textarea mt-2 ms-2"
                                        placeholder="Enter Claim Intimator Name"
                                        value={formData[FORM_KEYS.intimator_name]}
                                        maxLength={100}
                                        onChange={(e) => setValue(FORM_KEYS.intimator_name, e.target.value)}
                                    />
                                </div>
                                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                                    <p className="align3Policy">Relationship with Policyholder <AsteriskSymbol /></p>
                                    <Select
                                        classNamePrefix="truncate-placeholder"
                                        options={relationshipList}
                                        value={formData[FORM_KEYS.relationship] ? formData[FORM_KEYS.relationship] : null}
                                        styles={customStyles}
                                        onChange={(selectedOption) => setValue(FORM_KEYS.relationship, selectedOption)}
                                        required
                                        placeholder="Select Relationship"
                                    />
                                </div>
                                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                            <p className="align3Policy">Intimator Mobile Number</p>
                            <input
                                type="tel"
                                className="align3_dataPolicy mt-3"
                                name="tel"
                                id="tel"
                                placeholder="Enter Intimator Mobile Number"
                                maxLength={10}
                                onChange={(e) => {
                                    const numericValue = e.target.value.replace(/[^0-9.,]/g, '');
                                    e.target.value = numericValue;
                                    setValue(FORM_KEYS.intimator_mobile_number, e.target.value)
                                }}
                                value={formData[FORM_KEYS.intimator_mobile_number]}
                            />
                        </div>
                            </>
                        )}
                    </div>
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    </>
}

export default ClaimIntimatedDetails